import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import withStyles from '@material-ui/core/styles/withStyles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Tooltip from '@material-ui/core/Tooltip';
import { Apps, CloudDownload } from '@material-ui/icons';
import { FaTwitter, FaFacebook, FaInstagram } from 'react-icons/fa';
import CustomDropdown from '../CustomDropdown/CustomDropdown';
import Button from '../CustomButtons/Button';
import headerLinksStyle from '../../assets/jss/material-kit-react/components/headerLinksStyle';
function HeaderLinks({ ...props }) {
    const { classes } = props;
    return (React.createElement(List, { className: classes.list },
        React.createElement(ListItem, { className: classes.listItem },
            React.createElement(CustomDropdown, { noLiPadding: true, buttonText: "Components", buttonProps: {
                    className: classes.navLink,
                    color: 'transparent',
                }, buttonIcon: Apps, dropdownList: [
                    React.createElement(Link, { to: "/", className: classes.dropdownLink }, "All components"),
                    React.createElement("a", { href: "https://creativetimofficial.github.io/material-kit-react/#/documentation", target: "_blank", className: classes.dropdownLink }, "Documentation"),
                ] })),
        React.createElement(ListItem, { className: classes.listItem },
            React.createElement(Button, { href: "https://www.creative-tim.com/product/material-kit-react", color: "transparent", target: "_blank", className: classes.navLink },
                React.createElement(CloudDownload, { className: classes.icons }),
                " Download")),
        React.createElement(ListItem, { className: classes.listItem },
            React.createElement(Tooltip, { id: "instagram-twitter", title: "Follow us on twitter", placement: typeof window !== 'undefined' && window.innerWidth > 959
                    ? 'top'
                    : 'left', classes: { tooltip: classes.tooltip } },
                React.createElement(Button, { href: "https://twitter.com/CreativeTim", target: "_blank", color: "transparent", className: classes.navLink },
                    React.createElement(FaTwitter, null)))),
        React.createElement(ListItem, { className: classes.listItem },
            React.createElement(Tooltip, { id: "instagram-facebook", title: "Follow us on facebook", placement: typeof window !== 'undefined' && window.innerWidth > 959
                    ? 'top'
                    : 'left', classes: { tooltip: classes.tooltip } },
                React.createElement(Button, { color: "transparent", href: "https://www.facebook.com/CreativeTim", target: "_blank", className: classes.navLink },
                    React.createElement(FaFacebook, null)))),
        React.createElement(ListItem, { className: classes.listItem },
            React.createElement(Tooltip, { id: "instagram-tooltip", title: "Follow us on instagram", placement: typeof window !== 'undefined' && window.innerWidth > 959
                    ? 'top'
                    : 'left', classes: { tooltip: classes.tooltip } },
                React.createElement(Button, { color: "transparent", href: "https://www.instagram.com/CreativeTimOfficial", target: "_blank", className: classes.navLink },
                    React.createElement(FaInstagram, null))))));
}
HeaderLinks.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withStyles(headerLinksStyle)(HeaderLinks);
//# sourceMappingURL=HeaderLinks.js.map